import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  connect () {
    this.element.addEventListener('input', () => {
      this.element.value = this.element.value.replace(/\s+/g, '')
    })
  }
}
